import React, { useState, useEffect } from 'react'
import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import { Typography } from '@mui/material'
import { getPortfolioCategory } from '../../api'
import ProductShowcase from './ProductShowcase'

function Processchiller() {
  const [products, setProducts] = useState([])

  useEffect(() => {
    getPortfolioCategory('process_chiller').then(setProducts).catch(() => {})
  }, [])

  return (
    <>
      <Navbar />

      <main className='page-shell'>
        <div className='page-title-block'>
          <Typography className='page-title'>Process Chillers</Typography>
          <Typography className='page-subtitle'>
            Cooling for oil, milk, water, glycol and exo-gas processes.
          </Typography>
        </div>

        <div className='page-stack'>
          {products.map((p, i) => (
            <ProductShowcase
              key={i}
              title={p.specs.application}
              subtitle={p.specs.name}
              images={p.image_paths}
              specs={[
                { label: 'Installation', value: p.specs.installation },
                { label: 'Cooling capacity', value: p.specs.cooling_capacity },
                { label: 'Compressor', value: p.specs.compressor },
              ]}
              badges={[p.specs.plc]}
            />
          ))}
        </div>
      </main>

      <Footer />
    </>
  )
}

export default Processchiller
